export default __webpack_public_path__ + "static/media/2_flex_my_room.d77fc46f.svg";